__webpack_require__.p = "/tinder-clone/";